var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "de-sidebar-container",
      class: { "has-logo": _vm.showLogo },
    },
    [
      _vm.showLogo
        ? _c("logo", { attrs: { collapse: _vm.isCollapse } })
        : _vm._e(),
      _c(
        "el-menu",
        {
          staticClass: "de-el-menu",
          attrs: {
            "default-active": _vm.activeMenu,
            collapse: _vm.isCollapse,
            "unique-opened": false,
            "collapse-transition": false,
            mode: "vertical",
          },
        },
        _vm._l(_vm.routes, function (route) {
          return _c("sidebar-item", {
            key: route.path,
            attrs: {
              "is-collapse": _vm.isCollapse,
              item: route,
              "base-path": route.path,
            },
          })
        }),
        1
      ),
      _c(
        "div",
        {
          staticClass: "sidebar-collapse-btn",
          style: { width: _vm.isCollapse ? "64px" : "260px" },
          on: { click: _vm.changeSideWidth },
        },
        [
          _c("i", {
            staticClass: "el-icon-upload2",
            style: {
              transform: _vm.isCollapse ? "rotate(90deg)" : "rotate(-90deg)",
            },
          }),
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.isCollapse ? "" : _vm.$t("commons.collapse_navigation")
              ) +
              "\n  "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }